import { render, staticRenderFns } from "./EditOrderModalAdmin.vue?vue&type=template&id=320b518c&scoped=true"
import script from "./EditOrderModalAdmin.vue?vue&type=script&lang=js"
export * from "./EditOrderModalAdmin.vue?vue&type=script&lang=js"
import style0 from "./EditOrderModalAdmin.vue?vue&type=style&index=0&id=320b518c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b518c",
  null
  
)

export default component.exports